import styled from '@emotion/styled';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { ReactComponent as DeprecatedCancelIcon } from '../../../assets/icons/DeprecatedCancelIcon.svg';
import { ReactComponent as SearchIcon } from '../../../assets/icons/SearchIcon.svg';

interface IProps {
  dataCy?: string;
  value: string;
  onChange?: (searchQuery: string) => void;
  name?: string;
  className?: string;
  placeholder?: string;
  // delay for callback in ms
  delay?: number;
  dataIcom?: string;
  hideSearchIcon?: boolean;
}

const IconButton = styled.button`
  position: absolute;
  right: 14px;
  top: 6px;
  border: none;
  background: none;

  svg {
    color: #c1c1c1;
    fill: #c1c1c1;
  }
`;

const Container = styled.div`
  position: relative;
`;

export const SearchInput = ({
  dataCy,
  value,
  onChange,
  name,
  className,
  placeholder,
  delay = 500,
  dataIcom,
  hideSearchIcon,
}: IProps) => {
  const [currentValue, setCurrentValue] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange?.(currentValue);
    }, delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  const handleClick = () => {
    inputRef.current?.focus();
    if (currentValue) {
      setCurrentValue('');
    }
  };

  const handleChange = (e: ChangeEvent<any>) => {
    setCurrentValue(e.currentTarget.value);
  };

  return (
    <Container className={className} data-icom={dataIcom}>
      <FormControl
        data-cy={dataCy}
        ref={inputRef}
        type="text"
        name={name}
        placeholder={placeholder}
        value={currentValue}
        onChange={handleChange}
      />
      {!hideSearchIcon && (
        <IconButton onClick={handleClick}>{currentValue ? <DeprecatedCancelIcon /> : <SearchIcon />}</IconButton>
      )}
      {hideSearchIcon && currentValue && (
        <IconButton onClick={handleClick}>
          <DeprecatedCancelIcon />
        </IconButton>
      )}
    </Container>
  );
};
